module.exports = __webpack_public_path__ + "img/STYBIELLA_W.50ada6d7.png";